import styled from "styled-components";

export const LangRow = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const NumberField = styled.div`
    max-width: 180px;
`;
